import BoostPassiveAbstractStore from "./BoostPassiveAbstractStore";

export default class BoostSpeedStore extends BoostPassiveAbstractStore {}